"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sVersionExport = exports.sVersionRef = exports.sTranslationsForLanguageCode = exports.sTranslatablesWithTranslations = exports.sTranslatablesSyncResult = exports.sTranslatablesUpdate = exports.sVersionInfo = exports.sOrgOverview = void 0;
//import { semanticJson as s } from "@hediet/json-rpc";
const s = __importStar(require("@hediet/semantic-json"));
exports.sOrgOverview = s.sObject({
    orgId: s.sString(),
    isAdmin: s.sBoolean(),
    projects: s.sArrayOf(s.sObject({
        projectId: s.sString(),
    })),
});
exports.sVersionInfo = s.sOpenObject({
    name: s.sString(),
    iteration: s.sNumber(),
    id: s.sString(),
    locked: s.sBoolean(),
});
exports.sTranslatablesUpdate = s.sObject({
    defaultLanguageCode: s.sString(),
    includesAllPackages: s.sBoolean(),
    packages: s.sArrayOf(s.sObject({
        packageId: s.sString(),
        includesAllTranslatables: s.sBoolean(),
    })),
    translatables: s.sArrayOf(s.sObject({
        packageId: s.sString(),
        codeId: s.sString(),
        defaultFormat: s.sString(),
        description: s.sUnion([s.sString(), s.sNull()]),
    })),
});
exports.sTranslatablesSyncResult = s.sObject({
    addedTranslatables: s.sArrayOf(s.sObject({
        codeId: s.sString(),
        wasStale: s.sBoolean(),
    })),
    removedTranslatables: s.sArrayOf(s.sObject({
        codeId: s.sString(),
    })),
    updatedTranslatables: s.sArrayOf(s.sObject({
        codeId: s.sString(),
        defaultFormatUpdate: s.sUnion([
            s.sObject({
                kind: s.sLiteral("none"),
            }),
            s.sObject({
                kind: s.sLiteral("shouldUpdateSource"),
                suggestedDefaultFormat: s.sString(),
            }),
            s.sObject({
                kind: s.sLiteral("didUpdateDefaultLanguage"),
                oldTranslatedFormat: s.sUnion([s.sString(), s.sNull()]),
                newTranslatedFormat: s.sString(),
            }),
        ]),
    })),
});
exports.sTranslatablesWithTranslations = s.sObject({
    defaultLanguageCode: s.sString(),
    includesAllPackages: s.sBoolean(),
    languages: s.sArrayOf(s.sObject({ languageCode: s.sString() })),
    packages: s.sArrayOf(s.sObject({
        packageId: s.sString(),
        includesAllTranslatables: s.sBoolean(),
    })),
    translatables: s.sArrayOf(s.sObject({
        codeId: s.sString(),
        packageId: s.sString(),
        description: s.sUnion([s.sString(), s.sNull()]),
        translatableId: s.sNumber(),
        translations: s.sArrayOf(s.sObject({
            languageCode: s.sString(),
            translatedFormat: s.sUnion([s.sString(), s.sNull()]),
        })),
        //origin: s.sObject({}, { allowUnknownProperties: true }),
    })),
});
exports.sTranslationsForLanguageCode = s.sObject({
    languageCode: s.sString(),
    /** If not partial, all packages are included */
    includesAllPackages: s.sBoolean(),
    packagesById: s.sMap(s.sObject({
        includesAllTranslatables: s.sBoolean(),
        translationsByCodeId: s.sMap(s.sObject({
            translatedFormat: s.sString(), // might fall back to default language
            isUntranslatedInRequestedLanguage: s.sBoolean(),
            //origin: s.sObject({}, { allowUnknownProperties: true }),
        })),
    })),
});
exports.sVersionRef = s.sObject({
    orgId: s.sString(),
    projectId: s.sString(),
    versionId: s.sString(),
});
exports.sVersionExport = s.sObject({
    languages: s.sArrayOf(s.sObject({
        languageCode: s.sString(),
        name: s.sString(),
    })),
    defaultLanguageCode: s.sString(),
    translatables: s.sArrayOf(s.sObject({
        codeId: s.sString(),
        packageId: s.sString(),
        description: s.sUnion([s.sString(), s.sNull()]),
        translations: s.sArrayOf(s.sObject({
            languageCode: s.sString(),
            translatedFormat: s.sUnion([s.sString(), s.sNull()]),
        })),
    })),
});
//# sourceMappingURL=types.js.map